module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./DakaDownLoadView.js"));
	}, "DakaDownLoadView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DakaDownLoadView!./src/pages/DownLoad/daka/DakaDownLoadView.js
// module id = 2240
// module chunks = 367